import { normalizeEmail } from './emailUtils';

/**
 * Firebase Auth kimliğini tek kaynaktan çözer.
 * Sorgu filtreleri ve Firestore kuralları (auth.token) ile uyum için token yenilenir.
 */
export async function resolveAuthIdentity(user) {
  if (!user?.uid) {
    return { uid: '', email: '', phone: '', loginId: '' };
  }

  let email = normalizeEmail(user.email);
  let phone = user.phoneNumber || '';

  try {
    let tokenResult = await user.getIdTokenResult();
    const tokenMissingIdentity =
      (email && !tokenResult.claims?.email) || (phone && !tokenResult.claims?.phone_number);
    if (tokenMissingIdentity) {
      tokenResult = await user.getIdTokenResult(true);
    }
    if (tokenResult.claims?.email) {
      email = normalizeEmail(tokenResult.claims.email);
    }
    if (tokenResult.claims?.phone_number) {
      phone = tokenResult.claims.phone_number;
    }
  } catch (err) {
    console.warn('Auth token yenileme:', err);
  }

  return { uid: user.uid, email, phone, loginId: email || phone };
}
